"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterHotelResults = exports.checkIfHotelResults = void 0;
var filterPlainResults_1 = require("../filterPlainResults");
var checkIfHotelResults = function (results) {
    var hotelResultProperties = ["initialOption", "options"];
    return results.some(function (result) {
        if (typeof result !== "object")
            return false;
        var resultProperties = Object.keys(result);
        return hotelResultProperties.every(function (hotelProperty) {
            return resultProperties.includes(hotelProperty);
        });
    });
};
exports.checkIfHotelResults = checkIfHotelResults;
function filterHotelResults(results, appliedFiltersValues) {
    var filteredResults = results.map(function (result) {
        var option = result;
        var initialOptionFiltered = (0, filterPlainResults_1.filterPlainResults)([option === null || option === void 0 ? void 0 : option.initialOption], appliedFiltersValues);
        var otherOptionsFiltered = (0, filterPlainResults_1.filterPlainResults)(option === null || option === void 0 ? void 0 : option.options, appliedFiltersValues);
        var initialOptionWasFiltered = !!initialOptionFiltered.length;
        var someOtherOptionsFiltered = !!otherOptionsFiltered.length;
        if (!initialOptionWasFiltered && !someOtherOptionsFiltered)
            return;
        return __assign(__assign({}, option), { initialOption: addIsFilterPassedToInitialOption(option === null || option === void 0 ? void 0 : option.initialOption, initialOptionWasFiltered), options: otherOptionsFiltered });
    });
    return filteredResults.filter(function (option) { return option; });
}
exports.filterHotelResults = filterHotelResults;
var addIsFilterPassedToInitialOption = function (initialOption, isFilterPassed) {
    initialOption.isFilterPassed = isFilterPassed;
    return initialOption;
};
//# sourceMappingURL=index.js.map